import Header from "../../components/user/Header";
import ServicesSection from "../../components/user/sections/ServicesSection";
import Footer from "../../components/user/Footer";
import { useState } from "react";

export default function Services() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
    {/* Global font */}
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { margin: 0; padding: 0; }
    `}</style>

    {/* ── HEADER ── */}
    <Header onBookClick={() => setModalOpen(true)} />
        
    {/* ── SERVICE SECTION ── */}
    <ServicesSection />

    {/* ── FOOTER ── */}
    <Footer />
    </>
  );
}
